import React from 'react';

export function MapsNavigationIcon(props: JSX.IntrinsicElements['svg']) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
            width={20}
            height={20}
            {...props}
        >
            <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M9.14 18.91a.42.42 0 01-.78.05L1.28 1.82a.42.42 0 01.55-.54l17.13 7.08a.42.42 0 01-.05.78l-7.37 2.11a.42.42 0 00-.29.29l-2.1 7.37z"
            />
        </svg>
    );
}
